export const EHR_CAREGIVER_UNASSIGNMENT_WRITEBACK_FEATURE =
    'ehr_caregiver_unassignment_writeback_enabled';

export function isEhrCaregiverUnassignmentWritebackEnabled(
    features: Record<string, unknown> | null | undefined,
): boolean {
    return features?.[EHR_CAREGIVER_UNASSIGNMENT_WRITEBACK_FEATURE] === true;
}
